module.exports = __webpack_public_path__ + "public/images/bts_hero_image_2.d2e13fe2fd89daff3a3e421f11452379.webp";